<template>
  <label :class="componentClasses">
    <input
      type="checkbox"
      :checked="value"
      @change="updateValue"
    />
    <slot />
  </label>
</template>

<script setup>
import { computed, defineProps, defineEmits } from 'vue';

const props = defineProps({
  value: Boolean,
});

const emit = defineEmits(['input']);

const updateValue = (event) => {
  emit('input', event.target.checked);
};

const componentClasses = computed(() => [
  'stk-dropdown-checkbox',
  props.value && 'is-selected',
]);
</script>

<style>
.stk-dropdown-checkbox {
  border-radius: 0.5em;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.25em;
  padding: 0.25rem 0.5rem;
  transition-duration: var(--stk-transition-duration);
  transition-property: background-color;

  &:hover {
    background-color: var(--stk-primary-95);
  }

  &.is-selected {
    background-color: var(--stk-primary-95);
    box-shadow: inset 0 0 0 1px var(--stk-primary);
  }
}
</style>
